define('C3.ShoppingExtensions.VisualSystemPage.Collection',
  [
  'Utils',
  'SCCollection',
  'SCModel',
  'underscore'
  ],
  function (Utils,SCCollectionModule,SCModelModule,_) {
    'use strict';

     var SCCollection = SCCollectionModule.SCCollection;
     var SCModel = SCModelModule.SCModel;


     function VisualSystemPageCollection(models, options) {
      SCCollection.call(this, models, options);

      this.model = SCModel;

      this.customFilters = options && options.filters;


      this.url = function url () {
        return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/PLP.Service.ss"
                )
              )
      }

       this.parse = function parse(response) {
        
        return response;
      }

      this.update = function update(options){
         const data = {
              filter: options.filter,
              pageNumber: options.page || 1,
              resultsPerPage: options.resultsPerPage || 50,
              keyword : options.keyword
          };

         // console.log(data)
          
          this.fetch({
              data: data,
              reset: true,
              killerId: options.killerId
          });
      }
    }

    VisualSystemPageCollection.prototype = Object.create(SCCollection.prototype);
    VisualSystemPageCollection.prototype.constructor = VisualSystemPageCollection;

    return VisualSystemPageCollection;
    
  }
);
